export const LeftdisPg = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 12L19 12" stroke="#B4BFCD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13 6L19 12L13 18" stroke="#B4BFCD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
